import { useQuery } from "@tanstack/react-query"
import { Duration } from "luxon"

import MetricDisplay from "./MetricDisplay.tsx"
import MetricsCard from "./MetricsCard.tsx"

import type { DailyDisplayData } from "../types/dailyDisplayTypes.ts"

export default function DailyDisplay({
  fetcher,
  location,
  flareUnit,
}: {
  fetcher: () => Promise<DailyDisplayData>
  location: number
  flareUnit?: string
}) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["dailyDisplay", { location }],
    queryFn: fetcher,
    refetchInterval: 10000,
  })

  return (
    <MetricsCard title="Daily Totals">
      <MetricDisplay
        label="Gas to Pipeline"
        value={data ? data.gasToPipeline : 0}
        loading={isPending}
        error={isError}
        unit="MMBtu"
      />
      <MetricDisplay
        label="Gas Flared"
        value={data ? data.gasFlared : 0}
        loading={isPending}
        error={isError}
        unit={flareUnit || "MSCF"}
      />
      <MetricDisplay
        label="Gas to Pipeline Projection"
        loading={isPending}
        error={isError}
        unit="MMBtu"
        value={data && data.projection ? data.projection : 0}
      />
      <MetricDisplay
        label="Remaining Gas Day"
        loading={isPending}
        error={isError}
        value={
          data && data.remainingHours
            ? Duration.fromObject({ hours: data.remainingHours })
                .shiftTo("hours", "minutes")
                .toFormat("h:mm")
            : 0
        }
        unit="H:MM"
      />
    </MetricsCard>
  )
}
